module.exports = __webpack_public_path__ + "static/media/signup-provider-work-experience-info-en.468f7572.png";